'use client';

/**
 * X-UP Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { TrendingUp, Zap, UserPlus, Award } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.xUpPlan.hero"
                imageSrc="/images/mlm-plans/x-up_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.xUpPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.xUpPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.xUpPlan.features" />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.xUpPlan.commissions"
                commissions={[
                    { icon: TrendingUp, color: 'primary', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Zap, color: 'blue', titleKey: 'fastStart.title', descriptionKey: 'fastStart.description' },
                    { icon: UserPlus, color: 'green', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: Award, color: 'purple', titleKey: 'rankAdvancement.title', descriptionKey: 'rankAdvancement.description' },
                ]}
                gridCols="4"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.xUpPlan.whySoftware" />
        </div>
    );
}

